import { getOrdersCountApi } from "api/account/getOrdersCountApi";

export function getOrdersCount() {
  return (dispatch: any) => {
    const location = window.location.href;
    if (location.includes("/return-center") || location.includes("/account") || location.includes("/order-status")) {
      getOrdersCountApi().then(({ data }) => {
        dispatch({ type: "ORDERS_COUNT", data });
      }).catch((err) => {
        console.log("/get-orders-count failed", err);
      });
    }
  };
}
